import { PROFESSIONAL_STATUS_PRE } from '@/define/consts/professional/professional_user';
import { SERVICE_CLIENT_PROFFIT, SERVICE_PROFESSIONAL_PROFFIT, SERVICE_PROFESSIONAL_PROFFIT_MART, SERVICE_PROFFIT_SEARCH, SERVICE_SEMINAR_ENABLE, TWO_FACTOR_AUTHENTICATION, } from '@/define/consts/profile';
/**
 * @deprecated TS化した方を参照してください
 */
export const isLogin = (auth) => !!(auth && auth.payload && auth.payload.id);
/**
 * @deprecated TS化した方を参照してください
 */
export const isGuest = (auth) => !isLogin(auth);
/**
 * @deprecated TS化した方を参照してください
 */
export const isClient = (auth) => isLogin(auth) && auth.payload.type === 'client';
/**
 * @deprecated TS化した方を参照してください
 */
export const isProfessional = (auth) => isLogin(auth) && auth.payload.type === 'professional';
/**
 * @deprecated TS化した方を参照してください
 */
export const isFreeProfessional = (auth) => isLogin(auth) && auth.payload.type === 'free_professional';
/**
 * @deprecated TS化した方を参照してください
 */
export const isProfessionalPreStatus = (profile) => profile.status === PROFESSIONAL_STATUS_PRE;
/**
 * サービス利用可能かどうか判定
 * @deprecated TS化した方を参照してください
 * @param enableServices
 * @param name
 * @returns {boolean}
 */
const judgeEnableService = (enableServices, name) => enableServices.some((v) => v.name === name && v.enableAt);
/**
 * ユーザー別にサービス利用可能かどうか判定
 * @deprecated TS化した方を参照してください
 * @param profile
 * @param name
 * @returns {boolean}
 */
const judgeUserEnableService = (profile, name) => {
    const { enableServices = [] } = profile || {};
    return judgeEnableService(enableServices, name);
};
/**
 * 組織別にサービス利用可能かどうか判定
 * @param profile
 * @param name
 * @returns {boolean}
 */
const judgeOrganizatiopnEnableService = (profile, name) => {
    const { organizationEnableServices = [] } = profile || {};
    return judgeEnableService(organizationEnableServices, name);
};
/**
 * サービス利用許可審査中かどうか判定
 * @deprecated TS化した方を参照してください
 * @param profile
 * @param name
 * @returns {boolean}
 */
const judgeUnderExaminationService = (profile, name) => {
    const { enableServices = [] } = profile || {};
    return enableServices.some((v) => v.name === name && v.requestAt && !v.enableAt);
};
export const isCanUseOnlyProffitSearch = (profile) => {
    const { enableServices = [] } = profile || {};
    return (judgeUserEnableService(profile, SERVICE_PROFFIT_SEARCH) &&
        enableServices
            .filter((v) => v.name !== SERVICE_PROFFIT_SEARCH)
            .every((v) => !v.enableAt));
};
/**
 * @deprecated TS化した方を参照してください
 */
export const isCanUseProffitSearch = (profile) => judgeUserEnableService(profile, SERVICE_PROFFIT_SEARCH);
/**
 * @deprecated TS化した方を参照してください
 */
export const isCanUseProfessionalProffit = (profile) => judgeUserEnableService(profile, SERVICE_PROFESSIONAL_PROFFIT);
/**
 * @deprecated TS化した方を参照してください
 */
export const isCanUseProfessionalProffitMart = (profile) => judgeUserEnableService(profile, SERVICE_PROFESSIONAL_PROFFIT_MART);
/**
 * @deprecated TS化した方を参照してください
 */
export const isUnderExaminationProfessionalOrganizationProffitMart = (profile) => judgeUnderExaminationService(profile, SERVICE_PROFESSIONAL_PROFFIT_MART);
/**
 * @deprecated TS化した方を参照してください
 */
export const isCanUseClientProffit = (profile) => judgeUserEnableService(profile, SERVICE_CLIENT_PROFFIT);
/**
 * @deprecated TS化した方を参照してください
 */
export const isCanUseTwoFactorAuthentication = (profile) => judgeUserEnableService(profile, TWO_FACTOR_AUTHENTICATION);
/**
 * @deprecated TS化した方を参照してください
 */
export const isCanUseProfessionalSeminar = (profile) => judgeOrganizatiopnEnableService(profile, SERVICE_SEMINAR_ENABLE);
/**
 * @deprecated TS化した方を参照してください
 */
export const isClientPreStatus = (profile = {}) => Object.keys(profile).length > 0 && !isCanUseClientProffit(profile);
export const isAdmin = (profile) => !!profile.isAdmin;
/**
 * profileからuserの本名を取得
 * @deprecated 古い関数なのでts化した方を参照してください
 * @param profile
 * @returns {string}
 */
export const getFullName = (profile) => {
    if (!profile) {
        return '';
    }
    const { firstName, lastName } = profile.information || {};
    return ((lastName || firstName) && `${lastName} ${firstName}`) || '';
};
export const getFullNameAndKana = (profile, spacer = ' ') => {
    if (!profile) {
        return '';
    }
    const { firstName, firstNameKana, lastName, lastNameKana } = profile.information || {};
    const normalSpacer = lastName && firstName && spacer;
    const kanaSpacer = lastNameKana && firstNameKana && spacer;
    const normal = ((lastName || firstName) && `${lastName}${normalSpacer}${firstName}`) || '';
    const kana = ((lastNameKana || firstNameKana) &&
        `${lastNameKana}${kanaSpacer}${firstNameKana}`) ||
        '';
    return `${normal}${kana && `（${kana}）`}`;
};
/**
 * authに応じた文字列を返す
 * @param auth
 * @returns {string}
 */
export const getUserMode = (auth) => {
    let mode = 'guest';
    if (isProfessional(auth)) {
        mode = 'professional';
    }
    else if (isFreeProfessional(auth)) {
        mode = 'free_professional';
    }
    else if (isClient(auth)) {
        mode = 'client';
    }
    return mode;
};
